import App from 'lib/App';

const useChallengeIsNewlyShared = challenge => {
  const currentUserUsername = App.authentication.useCurrentUserUsername();
  return !challenge.row?.[currentUserUsername];
};

export default useChallengeIsNewlyShared;
